module.exports = __webpack_public_path__ + "img/首页室外机3.de980fd5.jpg";